module.exports = __webpack_public_path__ + "img/logan.0edbba0e.png";